import {PromotionBannerDto} from '../../common/shared/api/gateway/PromotionBannerDto.interface';
import {
  GroupType,
  PromotionBannerSection,
  SectionType,
} from '../generated/types';
import {createPromotionBannerItem} from './PromotionBannerItem';

export function createPromotionBannerSection({
  layoutId,
  promotionBanner,
}: {
  layoutId: string;
  promotionBanner: PromotionBannerDto;
}): PromotionBannerSection {
  const sectionId = `${layoutId}-section-promotion-banner`;
  return {
    id: sectionId,
    uid: promotionBanner.uid,
    type: SectionType.PromotionBanner,
    groups: [
      {
        id: `${sectionId}-group-promotion-banner`,
        type: GroupType.PromotionBanner,
        items: promotionBanner
          ? [createPromotionBannerItem(promotionBanner)]
          : [],
      },
    ],
  };
}
